import { getCurrentUserHasCore } from '@wix/da-shared-react/pkg/publicSession';
import { GallectionResourceType } from '@wix/da-shared-react/pkg/types/gallection';
import { ResourceType } from '@wix/da-shared-react/pkg/types/resource';
import { ALL_FOLDER_ID } from '@wix/da-url';
import { AppState } from '../../types/store';
import { getActiveSection } from './sections';
import { getCurrentlyViewedFolderId } from './gallectionSection';
import { getProfileOwnerUser } from './users';
import { getTimePeriod, getHasCalculatedStats } from './statsSection';

export function getBiExtraData(
  state: AppState
): {
  typeid: number;
  itemid: number;
  time_period?: string;
  non_core_view?: 0 | 1;
  is_empty_state_view?: 0 | 1;
} {
  const defaultsForUserProfiles = {
    typeid: ResourceType.USER,
    itemid: getProfileOwnerUser(state).userId,
  };
  const section = getActiveSection(state);

  switch (section) {
    case 'favourites':
    case 'gallery':
      const itemid = getCurrentlyViewedFolderId(state);

      if (!itemid || itemid === ALL_FOLDER_ID) {
        return defaultsForUserProfiles;
      }

      const typeid: number =
        section === 'gallery'
          ? GallectionResourceType.GALLERY
          : GallectionResourceType.COLLECTION;

      return {
        typeid,
        itemid,
      };

    case 'stats':
      return {
        ...defaultsForUserProfiles,
        time_period: getTimePeriod(state),
        non_core_view: getCurrentUserHasCore(state) ? 0 : 1,
        is_empty_state_view: getHasCalculatedStats(state) ? 0 : 1,
      };
    default:
      return defaultsForUserProfiles;
  }
}
